<app-terminal-overlay
    [title]="title()"
    subtitle="{{ 'GENERAL.SUBTITLE.SELECT_AMOUNT_OF_PRODUCT_BOXES' | translate }}"
    icon="fa-boxes-stacked"
    [activityType]="activityType()"
    [measurementType]="_activity?.measurementType"
    (closeRequested)="onCloseRequested()"
    (finishRequested)="onFinishRequested()"
>
    <app-product-box-amount
        (productBoxRegistrationsUpdated)="onProductBoxRegistrationsUpdated($event)"
        [activityAndProductBoxRegistrations]="{ activity: activity(), productBoxRegistrations }"
    />

    <app-manual-flow-footer
        data-footer
        (cancel)="onCloseRequested()"
        (next)="onSelectionComplete()"
        [nextEnabled]="areProductRegistrationsValid()"
        [cancelEnabled]="true"
    />
</app-terminal-overlay>
